export default "__VITE_ASSET__Rfivw1$n__"